import React, { useState } from "react";
import { Global } from "@emotion/react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { ReactComponent as ArrowUp } from "../assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../assets/icons/arrow-down.svg";
import { ReactComponent as SIM } from "../assets/images/sim.svg";
import InstagramIcon from "../assets/icons/instagram.svg";
import TiktokIcon from "../assets/icons/tiktok.svg";
import YoutubeIcon from "../assets/icons/youtube.svg";
import VenezuelaIcon from "../assets/icons/venezuela.svg";
import USAIcon from "../assets/icons/usa.svg";
import CanadaIcon from "../assets/icons/canada.svg";
import PuertoRicoIcon from "../assets/icons/puerto-rico.svg";
import FreefireIcon from "../assets/icons/Freefire.webp";
import PerplexityIcon from "../assets/images/perplexity.svg";
import FacebookIcon from "../assets/icons/facebook.svg";
import WhatsappIcon from "../assets/icons/whatsapp.svg";
import MessengerIcon from "../assets/icons/messenger.svg";
import WazeIcon from "../assets/icons/waze.svg";
import XIcon from "../assets/icons/x.webp";
import NequiIcon from "../assets/icons/nequi.svg";
import DaviPlataIcon from "../assets/icons/daviplata.svg";

export const SwipeableEdgeDrawer = ({
  tituloOferta,
  vigencia,
  datos,
  bonoBienvenida,
  appsIncluidas,
  simCard,
  envio,
  antes,
  ahora,
  total,
  freefire,
  youtube,
  perplexity,
  internacional,
  showTelnum,
  telNum = "",
}) => {
  const [open, setOpen] = useState(false);

  const drawerBleedingDown = open ? 55 : 105;

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <div className="flex sm:hidden h-full">
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(55% - ${drawerBleedingDown}px)`,
            overflow: "visible",
          },
        }}
      />

      <SwipeableDrawer
        className="flex sm:hidden"
        anchor="bottom"
        variant="temporary"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        onClick={toggleDrawer(!open)}
        allowSwipeInChildren
        disableDiscovery={true}
        swipeAreaWidth={drawerBleedingDown}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -drawerBleedingDown,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: "visible",
            zIndex: 9,
            right: 0,
            left: 0,
            height: 104,
          }}
        >
          <div className="flex flex-col">
            <div className="flex flex-row justify-between bg-primaryTelefonica">
              <Typography sx={{ p: 2, color: "text.secondary" }}>
                <span className="font-telefonicaBold text-white p-2">
                  Te estás portando con
                </span>
              </Typography>
              <Typography sx={{ p: 2, color: "text.secondary" }}>
                {open ? <ArrowDown /> : <ArrowUp />}
              </Typography>
            </div>

            <div
              className={`flex-row justify-between bg-white ${
                !open ? "flex" : "hidden"
              }`}
            >
              <Typography sx={{ p: 2, color: "text.secondary" }}>
                <span className="font-telefonicaBold text-[#000] p-2">
                  Total
                </span>
              </Typography>
              <Typography sx={{ p: 2, color: "text.secondary" }}>
                <span className="font-telefonicaBold text-[#000] p-2">
                  {total}
                </span>
              </Typography>
            </div>
          </div>
        </Box>
        <Box
          sx={{
            overflow: "auto",
            display: "flex",
            justifyContent: "center",
          }}
          className="h-[500px] sm:h-[300px]"
        >
          <PurchaseDetail
            tituloOferta={tituloOferta}
            vigencia={vigencia}
            datos={datos}
            bonoBienvenida={bonoBienvenida}
            appsIncluidas={appsIncluidas}
            simCard={simCard}
            envio={envio}
            antes={antes}
            freefire={freefire}
            perplexity={perplexity}
            youtube={youtube}
            internacional={internacional}
            ahora={ahora}
            total={total}
            telNum={telNum}
            showTelnum={showTelnum}
            className="flex pt-0 pb-1 sm:hidden"
          />
        </Box>
      </SwipeableDrawer>
    </div>
  );
};

export const PurchaseDetail = ({
  className,
  tituloOferta,
  vigencia,
  datos,
  bonoBienvenida,
  freefire,
  youtube,
  perplexity,
  internacional,
  appsIncluidas = "",
  simCard,
  envio,
  antes,
  ahora,
  total,
  showTelnum,
  telNum = "",
}) => {
  return (
    <div
      className={`${className} w-full sm:w-[547px] max-w-sm py-1 sm:py-6 font-telefonica`}
    >
      <div className="flex flex-col bg-white rounded-xl sm:pt-5 w-full space-y-4 h-auto sm:border sm:border-[#DDD] text-sm">
        <span className="hidden sm:flex font-telefonicaBold text-primaryTelefonica text-xl px-4">
          Te estás portando con:
        </span>
        <div className="flex flex-row justify-between items-end px-4">
          <div className="flex flex-row space-x-4 items-end">
            <div>
              <SIM />
            </div>
            <div>
              {showTelnum && (
                <p className="text-primaryTelefonica font-telefonicaBold flex">
                  Número de línea a portar
                </p>
              )}
              <p className="font-telefonicaBold">
                Paquete {tituloOferta} {datos}
              </p>
              <p className="text-[#737578]">Vigencia de {vigencia}</p>
            </div>
          </div>
          <div className="text-right">
            {showTelnum && (
              <p className="text-primaryTelefonica font-telefonicaBold flex">
                {telNum}
              </p>
            )}
            <p className="font-telefonicaBold">{ahora}</p>
            <p>&nbsp;</p>
          </div>
        </div>
        <div className="h-px w-full my-4 bg-[#EEE] mx-4" />
        <div className="flex flex-row justify-between font-telefonicaBold text-[#424b5a] px-4">
          <p className="text-[#737578] font-telefonica">Bono de bienvenida </p>
          <p className="font-telefonicaBold">{`${bonoBienvenida}`}</p>
        </div>
        <div className="flex flex-row justify-between font-telefonicaBold text-[#424b5a] px-4">
          <p className="flex items-center text-[#737578] font-telefonica">
            Apps ilimitadas
          </p>
          <div className="flex flex-col space-y-2">
            {freefire && (
              <div className="flex flex-row space-x-1 justify-end">
                <img
                  src={FreefireIcon}
                  alt="Freefire"
                  className="w-[111px] h-[17px]"
                />
              </div>
            )}
            <div className="flex flex-row space-x-1 justify-end">
              <img
                src={WhatsappIcon}
                alt="Whatsapp"
                className="w-[18px] h-[18px]"
              />
              <img
                src={FacebookIcon}
                alt="Facebook"
                className="w-[18px] h-[18px]"
              />
              <img
                src={MessengerIcon}
                alt="Messenger"
                className="w-[18px] h-[18px]"
              />
              <img src={WazeIcon} alt="Waze" className="w-[18px] h-[18px]" />
            </div>
            <div className="flex flex-row space-x-1 justify-center items-center">
              <img src={XIcon} alt="X" className="w-[18px] h-[18px]" />
              <img src={NequiIcon} alt="Nequi" className="w-[18px] h-[18px]" />
              <img
                src={DaviPlataIcon}
                alt="DaviPlata"
                className="w-[18px] h-[18px]"
              />
            </div>
          </div>
        </div>
        {perplexity && (
          <div className="flex flex-row justify-between font-telefonicaBold text-[#424b5a] px-4">
            <p className="flex items-center text-[#737578] font-telefonica">
              IA licencia por 2 meses
            </p>
            <div className="flex flex-col space-y-2">
              <div className="flex flex-row space-x-1 justify-end">
                <img
                  src={PerplexityIcon}
                  alt="Perplexity"
                  className="w-[111px] h-[17px]"
                />
              </div>
            </div>
          </div>
        )}
        {youtube !== undefined && (
          <div className="flex flex-row justify-between font-telefonicaBold text-[#424b5a] px-4">
            <p className="text-[#737578] font-telefonica">
              Apps con datos adicionales
            </p>

            <div className="flex flex-row space-x-1">
              <img
                src={InstagramIcon}
                alt="Instagram"
                className="w-[18px] h-[18px]"
              />
              <img
                src={TiktokIcon}
                alt="Tiktok"
                className="w-[18px] h-[18px]"
              />
              <img
                src={YoutubeIcon}
                alt="Youtube"
                className="w-[18px] h-[18px]"
              />
            </div>
          </div>
        )}
        {internacional !== undefined && (
          <div className="flex flex-row justify-between font-telefonicaBold text-[#424b5a] px-4">
            <p className="text-[#737578] font-telefonica">
              {internacional} Minutos Internacionales
            </p>
            <div className="flex flex-row space-x-1">
              <img
                src={VenezuelaIcon}
                alt="Venezuela"
                className="w-[26px] h-[17px]"
              />
              <img src={USAIcon} alt="USA" className="w-[26px] h-[17px]" />
              <img
                src={CanadaIcon}
                alt="Canada"
                className="w-[26px] h-[17px]"
              />
              <img
                src={PuertoRicoIcon}
                alt="PuertoRico"
                className="w-[26px] h-[17px]"
              />
            </div>
          </div>
        )}
        <div className="flex flex-row justify-between font-telefonicaBold text-[#424b5a] px-4">
          <p className="text-[#737578] font-telefonica">
            Minutos y SMS a todo operador
          </p>
          <p>Ilimitados</p>
        </div>
        <div className="h-px w-full my-4 bg-[#EEE] mx-4" />
        <div className="flex flex-row justify-between px-4">
          <label className="font-telefonicaBold text-[#424b5a]">Envío</label>
          <label className="font-telefonicaBold">{`${envio}`}</label>
        </div>
        <div className="flex flex-row justify-between bg-[#FAFAFA] p-4 rounded-b-xl">
          <label className="font-telefonicaBold text-[#424b5a]">TOTAL</label>
          <label className="font-telefonicaBold">{`${total}`}</label>
        </div>
      </div>
    </div>
  );
};
